module.exports = __webpack_public_path__ + "img/facebook.c7790d49.svg";